import React from 'react';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import ImagesList from './components/ImagesList';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

const DiySolarSystem: React.FC = () => {
    const { t } = useLang('theProduct.DiySolarSystem');
    const { locale } = getLocal();
    const images = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745287309897/pc-diy-sec2.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745287309897/pc-diy-sec2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745292775673/m-diy-sec2.jpg',
            thumbnailUrl: 'https://websiteoss.ecoflow.com/upload/image/1745287189649/pc-diy-thumbnail1.jpg',
            h5ThumbnailUrl: 'https://websiteoss.ecoflow.com/upload/image/1746511420122/image-5.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745287311066/pc-diy-sec3.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745287311066/pc-diy-sec3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745292775886/m-diy-sec3.jpg',
            thumbnailUrl: 'https://websiteoss.ecoflow.com/upload/image/1745287190350/pc-diy-thumbnail2.jpg',
            h5ThumbnailUrl: 'https://websiteoss.ecoflow.com/upload/image/1746511420843/image-4.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745287310069/pc-diy-sec4.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745287310069/pc-diy-sec4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745292776048/m-diy-sec4.jpg',
            thumbnailUrl: 'https://websiteoss.ecoflow.com/upload/image/1745287190165/pc-diy-thumbnail3.jpg',
            h5ThumbnailUrl: 'https://websiteoss.ecoflow.com/upload/image/1746511420637/image-3.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745287310471/pc-diy-sec5.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745287310471/pc-diy-sec5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745292776238/m-diy-sec5.jpg',
            thumbnailUrl: 'https://websiteoss.ecoflow.com/upload/image/1745287189981/pc-diy-thumbnail4.jpg',
            h5ThumbnailUrl: 'https://websiteoss.ecoflow.com/upload/image/1746511420261/image-2.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745287310258/pc-diy-sec6.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745287310258/pc-diy-sec6.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745292776420/m-diy-sec6.jpg',
            thumbnailUrl: 'https://websiteoss.ecoflow.com/upload/image/1745287189815/pc-diy-thumbnail5.jpg',
            h5ThumbnailUrl: 'https://websiteoss.ecoflow.com/upload/image/1746511420441/image-1.jpg',
        },
    ];

    return (
        <section className={styles.DiySolarSystem}>
            <div className="title">{t('diySolar_title')}</div>
            <div className="solor-container">
                <div className="top">
                    <ImagesList images={images} desc={t('diySolar_desc_1')} title={t('diySolar_title_1')}></ImagesList>
                </div>
                <div className="bottom-box">
                    <div className="left">
                        <div className="bottom-desc-box">
                            <p className="title1">{t('diySolar_title_2')}</p>
                            <p className="desc">{t('diySolar_desc_2')}</p>
                            <a href={`/${locale}/stream-microinverter`}>{t('diySolar_link')}</a>
                        </div>

                        <EcoImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1751272667123/%E5%8C%97%E7%BE%8E-AC%20Pro%201.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1751272667123/%E5%8C%97%E7%BE%8E-AC%20Pro%201.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1751272667123/%E5%8C%97%E7%BE%8E-AC%20Pro%201.jpg"
                        ></EcoImg>
                    </div>
                    <div className="right">
                        <div className="bottom-desc-box">
                            <p className="title1">{t('diySolar_title_3')}</p>
                            <p className="desc">{t('diySolar_desc_3')}</p>
                        </div>

                        <EcoImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1745293680494/pc-diy-sec8.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1745293680494/pc-diy-sec8.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1745293720049/m-diy-sec8.jpg"
                        ></EcoImg>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DiySolarSystem;
